import { navigation } from './navigationState'

export const initialState = {
  navigation,
  user: {},
  point: {},
}